<template>
    <paper class="base_config">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            searchId="base_config"
            pageID="base_config251031"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @configTab-btn="configTab"
            @configField-btn="configField"
            @configQualification-btn="configQualification"
            @sizeChange="sizeChange">
            <div slot="table-module-btn" class="btn-box">
                <el-tooltip effect="dark" content="新增" placement="bottom">
                    <el-button class="bigData-btn-add" v-has="buttonPermission[0]" type="primary" size="mini" icon="el-icon-plus" @click="handleAdd"></el-button>
                </el-tooltip>
            </div>
            <div slot="page-module-btn">
                <el-button class="bigData-btn-delete" v-has="buttonPermission[2]" type="primary" @click="handleDelete">删除</el-button>
                <el-button class="bigData-btn-on" v-has="buttonPermission[3]" type="primary" @click="handleStatus(true)">启用</el-button>
                <el-button class="bigData-btn-off" v-has="buttonPermission[4]" type="primary" @click="handleStatus(false)">停用</el-button>
            </div>
        </m-pane>
        <config-tab-dialog
            :tabData="tabData"
            :openConfigTabDialog="openConfigTabDialog"
            @closeDialog="closeConfigTabDialog"
            @confirmDialog="confirmConfigTabDialog">
        </config-tab-dialog>
        <config-field-dialog
            :fieldData="fieldData"
            :openConfigFieldDialog="openConfigFieldDialog"
            :overseaSwitch="overseaSwitch"
            @closeDialog="closeConfigFieldDialog"
            @confirmDialog="confirmConfigFieldDialog">
        </config-field-dialog>
        <add-or-edit-dialog
            :openAddOrEditDialog="openAddOrEditDialog"
            :row="row"
            :addOrEdit="addOrEdit"
            :overseaSwitch="overseaSwitch"
            @closeDialog="closeAddOrEditDialog"
            @confirmDialog="confirmAddOrEditDialog">
        </add-or-edit-dialog>
        <config-qlf-dialog
            :qlfData="qlfData"
            :openConfigQlfDialog="openConfigQlfDialog"
            @closeDialog="closeConfigQlfDialog"
            @confirmDialog="confirmConfigQlfDialog">
        </config-qlf-dialog>
    </paper>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api';
import {
    getTypeConfigs, addTypeConfig, updateTypeConfig, deleteTypeConfigs, startTypeConfigs, blockTypeConfigs,
    getTabConfigs, saveOrUpdateTabConfigs,
    getFieldConfigs, saveOrUpdateBasicInfoConfigs,
    getQualificationConfigs, saveOrUpdateQualificationConfigs
} from '../../../../api/baseConfig';
import { getSysControlParamByCode } from '../../../../api/toDo/sysParamsConfig.js'
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import configTabDialog from './ConfigTabDialog.vue';
import configFieldDialog from './ConfigFieldDialog.vue';
import addOrEditDialog from './AddOrEditDialog.vue';
import configQlfDialog from './ConfigQlfDialog.vue';

const BUTTON_PERMISSION = ['04000101', '04000102', '04000103', '04000104', '04000105'];

export default {
    name: 'baseConfig',
    components: { mPane, paper, configTabDialog, configFieldDialog, addOrEditDialog, configQlfDialog },
    data() {
        return {
            tabData: [],
            openConfigTabDialog: false,
            fieldData: [],
            openConfigFieldDialog: false,
            openAddOrEditDialog: false,
            qlfData: [],
            openConfigQlfDialog: false,
            openDeleteDialog: false,
            addOrEdit: false, // false ===> 编辑, true ===> 增加
            row: {},
            selected: [],
            currentPage: 1,
            searchObj: {
                pageNo: 1,
                pageSize: 10
            },
            pageTotal: 0,
            totalData: [],
            loading: false,
            currentId: null,
            currentRecord: null,
            dict: {},
            buttonPermission: BUTTON_PERMISSION,
            overseaSwitch: true,
        };
    },
    computed: {
        config() {
            const configTemp = config
            if (this.overseaSwitch) {
                configTemp.table.columns.filter(item => item.prop !== 'isOverseas_')
            }
            return configTemp
        },
    },
    methods: {
        pageChange(pageNo) {
            this.currentPage = pageNo;
            this.searchObj = {
                ...this.searchObj,
                pageNo
            };
            this.getList();
        },
        sizeChange(pageSize) {
            this.currentPage = 1;
            this.searchObj = {
                ...this.searchObj,
                pageSize,
                pageNo: 1
            };
            this.getList();
        },
        searchChange(data) {
            this.currentPage = 1;
            this.searchObj = {
                ...this.searchObj,
                ...data,
                pageNo: 1
            };
            this.getList();
        },
        rowDBclick(row) {
            this.currentId = row.id;
            this.addOrEdit = false;
            this.openAddOrEditDialog = true;
            this.row = row;
        },
        selectChange(data) {
            this.selected = data.map(item => (item.id));
        },
        /** 新增 **/
        handleAdd() {
            this.row = {
                id: null,
                supplierType: '',
                property: '',
                businessType: '',
                transportType: '',
                corporateType: '',
                lesseeType: '',
                transType: ''
            };
            this.addOrEdit = true;
            this.openAddOrEditDialog = true;
        },
        closeAddOrEditDialog() {
            this.openAddOrEditDialog = false;
            this.row = {};
        },
        confirmAddOrEditDialog(data) {
            const params = {
                ...data.data
            };
            if (data.addOrEdit) {
                addTypeConfig(params).then(res => {
                    if (res) {
                        this.$message.success('新增成功!');
                        this.currentPage = 1;
                        this.searchObj = {
                            ...this.searchObj,
                            pageNo: 1
                        };
                        this.getList();
                        this.openAddOrEditDialog = data.close;
                    }
                });
            } else {
                params.id = this.currentId;
                updateTypeConfig(params).then(res => {
                    if (res) {
                        this.$message.success('编辑成功!');
                        this.getList();
                        this.openAddOrEditDialog = data.close;
                    }
                });
            }
        },
        handleDelete() {
            if (this.selected.length <= 0) {
                this.$message.success('请选择要删除的数据!');
                return false;
            }
            this.$confirm('删除选中数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteTypeConfigs({ ids: this.selected }).then(res => {
                    if (res && res.data) {
                        this.$message.success('删除成功!');
                        this.getList();
                    }
                });
            });
        },
        handleStatus(flag) {
            const ids = this.selected;
            if (ids.length <= 0) {
                this.$message.warning(`请选择要${flag ? '启用' : '停用'}的数据！`);
                return false;
            }
            if (flag) {
                startTypeConfigs({ ids }).then(res => {
                    if (res) {
                        this.$message.success('启用成功!');
                        this.getList();
                    }
                });
            } else {
                blockTypeConfigs({ ids }).then(res => {
                    if (res) {
                        this.$message.success('停用成功!');
                        this.getList();
                    }
                });
            }
        },
        /** 配置标签 data是当行数据 **/
        configTab(data) {
            this.currentRecord = data;
            this.currentId = data.id;
            this.openConfigTabDialog = true;
            getTabConfigs({ basicTypeCode: data.basicTypeCode }).then(res => {
                if (res.data) {
                    this.tabData = res.data.list.map(item => {
                        return {
                            id: item.id,
                            tabConfigCode: item.tabConfigCode,
                            tabName: item.tabName,
                            operation: item.required === 'T'
                        };
                    });
                }
            });
        },
        closeConfigTabDialog(data) {
            this.openConfigTabDialog = data;
        },
        confirmConfigTabDialog(data) {
            const { basicTypeCode } = this.currentRecord;
            const tabConfigList = data.data.map(item => {
                const newItem = {
                    basicTypeCode,
                    tabConfigCode: item.tabConfigCode,
                    tabName: item.tabName,
                    required: item.operation ? 'T' : 'F'
                };
                if (item.id) {
                    newItem.id = item.id;
                }
                return newItem;
            });
            saveOrUpdateTabConfigs({ tabConfigList }).then(res => {
                if (res) {
                    this.$message.success('标签配置成功!');
                    this.openConfigTabDialog = data.close;
                }
            });
        },
        /** 配置字段 **/
        configField(data) {
            this.currentRecord = data;
            this.currentId = data.id;
            this.openConfigFieldDialog = true;
            getFieldConfigs({ basicTypeCode: data.basicTypeCode, pageNo: 1, pageSize: 999 }).then(res => {
                if (res.data) {
                    this.fieldData = res.data.list.map(item => {
                        return {
                            id: item.id,
                            fieldName: item.fieldName,
                            fieldCode: item.fieldCode,
                            requiredFlag: item.requiredFlag,
                            disabledFlag: item.disabledFlag,
                            editorType: item.editorType,
                            editorOption: item.editorOption
                        };
                    });
                }
            });
        },
        closeConfigFieldDialog(data) {
            this.openConfigFieldDialog = data;
        },
        confirmConfigFieldDialog(data) {
            const { basicTypeCode } = this.currentRecord;
            const basicinfoConfigList = data.data.map(item => {
                item.basicTypeCode = basicTypeCode;
                return item;
            });
            saveOrUpdateBasicInfoConfigs({ basicTypeCode, basicinfoConfigList }).then(res => {
                if (res) {
                    this.$message.success('字段配置成功!');
                    this.openConfigFieldDialog = data.close;
                }
            });
        },
        /** 配置资质配置 **/
        configQualification(data) {
            this.currentId = data.id;
            this.currentRecord = data;
            this.openConfigQlfDialog = true;

            getQualificationConfigs({ basicTypeCode: data.basicTypeCode }).then(res => {
                if (res.data) {
                    this.qlfData = res.data.list.map(item => {
                        return {
                            id: item.id,
                            basicTypeCode: data.basicTypeCode,
                            qualificationName: item.qualificationName,
                            qualificationConfigCode: item.qualificationConfigCode,
                            requiredFlag: item.requiredFlag,
                            typeNumber: item.typeNumber
                        };
                    });
                }
            });
        },
        closeConfigQlfDialog(data) {
            this.openConfigQlfDialog = data;
        },
        confirmConfigQlfDialog(data) {
            const { basicTypeCode } = this.currentRecord;
            const qualificationConfigList = data.data.map(item => {
                item.basicTypeCode = basicTypeCode;
                return item;
            });
            saveOrUpdateQualificationConfigs({ qualificationConfigList }).then(res => {
                if (res) {
                    this.$message.success('资质配置成功!');
                    this.openConfigQlfDialog = data.close;
                }
            });
        },
        getList() {
            getTypeConfigs(this.searchObj).then(res => {
                if (res) {
                    this.pageTotal = res.data.totalCount;
                    this.totalData = this.formatData(res.data.list);
                }
            });
        },
        formatData(data) {
            return data.map(item => {
                item.supplierType_ = this.dict.SYS_SUPPLIERS_TYPE[item.supplierType];
                item.property_ = this.dict.SYS_SUPPLIERS_PROPERTY[item.property];
                item.isOverseas_ = this.dict.SRM_IS_OVERSEAS[item.isOverseas];
                item.businessType_ = this.dict.SRM_BUSYNESS_TYPE_BACKGROUND[item.businessType];
                item.transportType_ = this.dict.SRM_TRANSPORT_TYPE[item.transportType];
                item.transType_ = this.dict.SRM_SHIPPER_TYPE[item.transType];
                item.corporateType_ = this.dict.SU_CORPORATE_TYPE[item.corporateType];
                item.lesseeType_ = this.dict.SU_LEASE_TYPE[item.lesseeType];
                item.cooperationWays_ = this.dict.SU_CORPORATE_TYPE_RL[item.cooperationWays];
                item.typeStatus_ = item.typeStatus === 0 ? '启用' : '停用';
                return item;
            });
        }
    },
    mounted() {
        dictWithUrl('SYS_SUPPLIERS_TYPE,SYS_SUPPLIERS_PROPERTY,SRM_IS_OVERSEAS,SRM_BUSYNESS_TYPE_BACKGROUND,SRM_TRANSPORT_TYPE,SRM_SHIPPER_TYPE,SU_CORPORATE_TYPE,SU_LEASE_TYPE,SU_CORPORATE_TYPE_RL')
            .then(res => {
                if (res && +res.code === 0) {
                    this.dict = res.data;
                    this.getList();
                }
            });
        getSysControlParamByCode({ controlCode: 'OVERSEA_SWITCH' }).then(res => {
            if (res && +res.code === 0 && res.data) {
                this.overseaSwitch = !!JSON.parse(res.data)
            }
        })
    }
};
</script>

<style lang="less">
    .base_config {
        margin: 8px;
    }
</style>
